import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes, Link } from 'react-router-dom';
import Dashboard from 'pages/Dashboard/Dashboard';
import UnitsOverview from 'pages/UnitsOverview/UnitsOverview'
import MyProfile from 'pages/MyProfile/MyProfile'
import MyLicense from 'pages/MyLicense/MyLicense'
import Users from 'pages/Users/Users'
import Companies from 'pages/Companies/Companies'
import UnitsManagement from 'pages/UnitsManagement/UnitsManagement'
import SystemEvents from 'pages/SystemEvents/SystemEvents'
import Licenses from 'pages/Licenses/Licenses'
import CrashReports from 'pages/CrashReports/CrashReports'

import Login from 'pages/Login/Login';
import Signin from 'pages/Signin/Signin'
import Sidenav from 'components/Sidenav/Sidenav'
import StartPage from './StartPage'
import Logout from 'pages/Login/Logout'
import Preferences from 'pages/Preferences/Preferences';
import Secret from 'pages/Secret/Secret'
import Unauthorized from 'pages/Unauthorized/Unauthorized';
import Protect from 'pages/Protected/Protected';
import Missing from 'pages/Missing/Missing';
import SidebarLayout from './SidebarLayout'
import axiosInterceptor from 'components/utils/axiosInterceptor'
import { AuthProvider } from 'context/authProvider';
import useToken from './useToken';
import Auth from './Auth';

function App() {
  return (

      <AuthProvider>
        <Routes>
          <Route path='/logout' element={<Logout/>} />
            <Route element={<SidebarLayout/>}>
              <Route element={<Auth allowedRoles={['user','super_user']}/>}>
                <Route path="/" element={<StartPage/>} />
                <Route path="/unitsOverview" element={<UnitsOverview/>} />
                <Route path="/myProfile" element={<MyProfile/>} />
                <Route path="/myLicense" element={<MyLicense/>} />
              </Route>
              <Route element={<Auth allowedRoles={['super_user']}/>}>
                <Route path="/dashboard" element={<Dashboard/>} />
                <Route path='/users' element={<Users/>}/>
                <Route path='/companies' element={<Companies/>}/>
                <Route path='/unitsManagement' element={<UnitsManagement/>}/>
                <Route path='/systemEvents' element={<SystemEvents/>}/>
                <Route path='/licenses' element={<Licenses/>}/>
                <Route path='/crashReports' element={<CrashReports/>}/>
                <Route path='/protected' element={<Protect/>}/>
                <Route path='/restricted' element = {<Secret/>}/>
              </Route>
              <Route path='/unauthorized' element={<Unauthorized/>}/>
            </Route>
          <Route path ='/signin' element={<Signin />}/>
          <Route path="*" element={<Missing />} />
        </Routes>
      </AuthProvider>

  );
}

export default App;
